<template>
    <Breadcrumb :items="breadcrumbs" />
    <div class="absence-page container-fluid my-3">
        <div class="filter my-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
                <h4>شيت الدفع {{ grade?.name ?? '' }} ({{ paggination }})</h4>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-12 col-12">
                    <div class="form-group">
                        <label for="search">ابحث</label>
                        <input type="search" id="search" class="form-control" placeholder="ابحث" v-model="word"
                            @keyup="onFilterChange">
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-12">
                    <div class="form-group d-flex flex-column">
                        <label for="gender">الجنس</label>
                        <Dropdown v-model="gender" :options="gender_list" optionLabel="title"
                            placeholder="الجنس" @change="onFilterChange" />
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-12">
                    <div class="form-group d-flex flex-column">
                        <label for="studyMode">وضع الدراسة</label>
                        <Dropdown v-model="studyMode" :options="studyModeOptions" optionLabel="title"
                            placeholder="وضع الدراسة" @change="onFilterChange" />
                    </div>
                </div>
                <div class="col-lg-2 col-md-3 col-12">
                    <div class="d-flex">
                        <div class="form-group d-flex flex-column mx-1">
                            <label for="" class="non_opacity">طباعة</label>
                            <button class="btn btn-success px-3" @click="exportToExcel">
                                <i class="pi pi-file-excel"></i>
                            </button>
                        </div>
                        <div class="form-group d-flex flex-column mx-1">
                            <label for="" class="non_opacity">طباعة</label>
                            <button class="btn btn-danger px-3" @click="printTable" :disabled="printing">
                                <i class="pi pi-spinner pi-spin" v-if="printing"></i>
                                <i class="pi pi-file-pdf" v-else></i>
                            </button>
                            <!-- Reused by printTable() so vue3-print-nb clones #reservationTable
                                 AFTER the full (unpaginated, still-filtered) dataset has been
                                 fetched and rendered — the visible button no longer carries
                                 v-print directly because the directive reads the DOM
                                 synchronously on click, before an async fetch could resolve. -->
                            <button ref="printTrigger" v-print="'#reservationTable'" style="display:none"
                                aria-hidden="true" tabindex="-1"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
          <div id="reservationTable" class="a4">
            <div class="first-screen-pdf">
              <img src="@/assets/images/logo_navbar.png" alt="logo" class="cover-logo">
              <h1>شيت دفع</h1>
              <h2>{{ grade?.name ?? '' }}</h2>
              <h3>{{ gender?.id === 1 ? "بنين" : gender?.id === 2 ? "بنات" : "" }} ( {{ paggination }} )</h3>
            </div>
            <div class="table-scroll-x">
            <table class="table table-striped table-confirm">
                <thead>
                    <tr>
                        <th scope="col" rowspan="2" class="col-index">رقم</th>
                        <th scope="col" rowspan="2" class="col-name">
                            الاسم
                            <!-- Print-only: merges with the booking-number column below so the
                                 printed table doesn't waste a whole column on it. Hidden on
                                 screen, where the dedicated رقم الحجز column already shows it. -->
                            <span class="print-only-inline">(ورقم الحجز)</span>
                        </th>
                        <th scope="col" rowspan="2" class="col-booking">رقم الحجز</th>
                        <th scope="col" rowspan="2" class="col-parent">رقم ولي الامر</th>
                        <th scope="col" colspan="11">الشهور</th>

                    </tr>
                    <tr>
                        <th class="month">8</th>
                        <th class="month">9</th>
                        <th class="month">10</th>
                        <th class="month">11</th>
                        <th class="month">12</th>
                        <th class="month">1</th>
                        <th class="month">2</th>
                        <th class="month">3</th>
                        <th class="month">4</th>
                        <th class="month">5</th>
                        <th class="month">6</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(reservation, index) in reservations.data" :key="index">
                        <td data-label="ID" class="col-index">{{ index + 1 }}</td>
                        <td data-label="الاسم" class="col-name">
                            <span class="print-name-text">{{ reservation.name }}</span>
                            <span v-if="reservation.reservation_number" class="print-only-inline">
                                — {{ reservation.reservation_number }}
                            </span>
                        </td>
                        <td data-label="رقم الحجز" class="col-booking">{{ reservation.reservation_number }}</td>
                        <td data-label="رقم ولي الامر" class="col-parent">{{ reservation.parent_phone }}</td>
                        <td data-label="8" class="month-cell">

                        </td>
                        <td data-label="9" class="month-cell">

                        </td>
                        <td data-label="10" class="month-cell">

                        </td>
                        <td data-label="11" class="month-cell">
                        </td>
                        <td data-label="12" class="month-cell">
                        </td>
                        <td data-label="1" class="month-cell">
                        </td>
                        <td data-label="2" class="month-cell">
                        </td>
                        <td data-label="3" class="month-cell">
                        </td>
                        <td data-label="4" class="month-cell">
                        </td>
                        <td data-label="5" class="month-cell">
                        </td>
                        <td data-label="6" class="month-cell">
                        </td>
                    </tr>
                    <!-- Add empty rows if needed -->
                    <tr v-for="n in extraRows" :key="'empty-' + n" class="empty-row">
                      <td class="col-index">{{ reservations.data.length + n }}</td>
                      <td data-label="الاسم" class="col-name"></td>
                      <td data-label="رقم الحجز" class="col-booking"></td>
                      <td data-label="رقم ولي الامر" class="col-parent"></td>
                      <td data-label="8" class="month-cell">

                      </td>
                      <td data-label="9" class="month-cell">

                      </td>
                      <td data-label="10" class="month-cell">

                      </td>
                      <td data-label="11" class="month-cell">
                      </td>
                      <td data-label="12" class="month-cell">
                      </td>
                      <td data-label="1" class="month-cell">
                      </td>
                      <td data-label="2" class="month-cell">
                      </td>
                      <td data-label="3" class="month-cell">
                      </td>
                      <td data-label="4" class="month-cell">
                      </td>
                      <td data-label="5" class="month-cell">
                      </td>
                      <td data-label="6" class="month-cell">
                      </td>
                    </tr>
                </tbody>
            </table>
            </div>
          </div>
        </div>
        <div class="row">
            <div class="col-md-10 col-12">
                <pagination :data="reservations"
                    class="mx-auto d-flex align-items-center justify-content-center pagination"
                    @pagination-change-page="fetchReservation">
                    <template v-slot:prev-nav>&lt;</template>
                    <template v-slot:next-nav>&gt;</template>
                </pagination>
            </div>
            <div class="col-md-2 col-12 mt-md-0 mt-3">
                <div class="form-group d-flex md-justify-content-end justify-content-center">
                    <Dropdown v-model="per_page" :options="per_pages" showClear optionLabel="title"
                        placeholder="عدد الطلاب" @change="onFilterChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import pagination from "laravel-vue-pagination";
import * as XLSX from "xlsx/xlsx.mjs";
import Breadcrumb from '@/components/global/breadcrumb.vue';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
    name: "reservation-page",
    data() {
        return {
            reservations: {
                data: [],
            },
            certificate_image: "",
            visible: false,
            word: "",
            status: null,
            degree: "",
            gender: {
                id: 1,
                title: "ولد",
            },
            per_pages: [
                {
                    title: "الكل",
                    id: 10000,
                },
                {
                    title: 10,
                    id: 10,
                },
                {
                    title: 25,
                    id: 25,
                },
                {
                    title: 50,
                    id: 50,
                },
                {
                    title: 100,
                    id: 100,
                },
            ],
            per_page: null,
            paggination: "",
            sortAsc: true,
            orderByName: true,
            currentPage: 1,
            printing: false,
            gender_list: [
                {
                    id: 1,
                    title: "ولد",
                },
                {
                    id: 2,
                    title: "بنت",
                },
            ],
            // "أونلاين + أوفلاين" is NOT "online OR offline" — it's the label
            // for the third, independent study-mode value: Hybrid. Confirmed
            // against grades/add_student.vue, where the exact same label maps
            // to `value: 'hybrid'` (STUDY_MODE_OPTIONS) and is itself already
            // the default for new student registration. The backend filter
            // (AdminReservationApiService::index) does a plain
            // `where('study_mode', $params->study_mode)` — reusing that same
            // 'hybrid' string here filters to exactly the Hybrid students,
            // never a union of online+offline.
            studyMode: { id: "hybrid", title: "أونلاين + أوفلاين" },
            studyModeOptions: [
                { id: "online", title: "أونلاين" },
                { id: "offline", title: "أوفلاين" },
                { id: "hybrid", title: "أونلاين + أوفلاين" },
            ],
        }
    },
    components: {
        Button,
        Dropdown,
        pagination,
        Breadcrumb
    },
    computed: {
        gradeStore() { return useGradeStore(); },
        gradeSlug() {
            return this.$route.params.gradeSlug;
        },
        grade() {
            const slug = this.gradeSlug;
            if (!slug) return null;
            return this.gradeStore.activeGrades.find(g => g.slug === slug)
                || this.gradeStore.allGrades.find(g => g.slug === slug)
                || null;
        },
        gradeId() {
            return this.grade?.id ?? null;
        },
        breadcrumbs() {
            const gradeName = this.grade?.name ?? this.gradeSlug ?? '';
            const gradePath = this.grade
                ? `/grades/${this.grade.slug}/students`
                : '/';
            return [
                { name: 'الرئيسية', path: '/' },
                { name: gradeName, path: gradePath },
                { name: 'شيت الدفع', path: this.$route.fullPath },
            ];
        },
        extraRows() {
            return 27 - (Number(this.paggination) % 27);
        },
    },
    methods: {
        // Shared by fetchReservation() (paginated, screen view) and
        // printTable() (unpaginated, full filtered set) so both requests stay
        // in sync with word/gender/study_mode — a print that silently ignored
        // the active filters would be a worse bug than the blank-page one.
        buildFilterFormData() {
            const formData = new FormData();
            formData.append('status', 1);
            formData.append('order_by_name', 1);
            if (this.gradeId) {
                formData.append('academic_year_id', this.gradeId);
            }
            if (this.word) {
                formData.append('word', this.word);
            }
            if (this.gender) {
                formData.append('gender', this.gender.id);
            }
            // Every option now maps to a real, distinct study_mode value
            // (online/offline/hybrid) — unlike the old 'all' sentinel, there's
            // no "skip the filter" case any more; the dropdown always narrows
            // to exactly one study mode.
            if (this.studyMode?.id) {
                formData.append('study_mode', this.studyMode.id);
            }
            return formData;
        },
        fetchReservation(page = 1) {
            const formData = this.buildFilterFormData();

            const pageNumber = Number.isInteger(page) ? page : (parseInt(page, 10) || 1);
            const perPageValue = this.per_page == null ? 10 : this.per_page.id;
            this.currentPage = pageNumber;

            return axios
                .post(`/all_reservations?page=${pageNumber}&per_page=${perPageValue}`, formData)
                .then((response) => {
                    this.reservations = response.data.data;
                    this.paggination = response.data.data.meta.total;
                })
                .catch((error) => {
                    this.reservations = {};
                });
        },
        onFilterChange() {
            this.fetchReservation(1);
        },

        // The PDF/print button used to bind `v-print` directly, which reads
        // #reservationTable's DOM synchronously the instant it's clicked —
        // so printing only ever captured whatever page was currently loaded
        // (10 rows by default), not "all rows respecting the current
        // filters" that a real attendance/payment sheet needs. This fetches
        // the complete filtered set first, waits for Vue to render it into
        // #reservationTable, THEN fires the hidden v-print-bound button so
        // the directive clones the now-complete table. The visible
        // pagination is restored right after, since vue3-print-nb clones the
        // DOM synchronously on click — by the time it fires, the clone
        // already happened, so reverting the on-screen state doesn't affect
        // what's being printed.
        async printTable() {
            if (this.printing) return;
            this.printing = true;
            const pageToRestore = this.currentPage;
            try {
                const formData = this.buildFilterFormData();
                const response = await axios.post('/all_reservations?page=1&per_page=100000', formData);
                this.reservations = response.data.data;
                this.paggination = response.data.data.meta?.total ?? this.paggination;
                await this.$nextTick();
                this.$refs.printTrigger?.click();
            } catch (error) {
                // Fall back to whatever is currently rendered rather than
                // silently failing to print at all.
                this.$refs.printTrigger?.click();
            } finally {
                await this.fetchReservation(pageToRestore);
                this.printing = false;
            }
        },

        getEducationLevelLabel(level) {
          const levels = {
            1: "الاول الاعدادي",
            2: "الثاني الاعدادي",
            3: "الثالث الاعدادي",
            4: "الاول الثانوي",
            5: "الثاني الثانوي",
            6: "الثالث الثانوي",
          };
          return levels[level] || `${level}`;
        },

        getEducationLevelPath(level) {
          if (level == 3) return '/reservation';
          if (level == 4) return '/one_secondary';
          if (level == 5) return '/two_secondary';
          if (level == 6) return '/three_secondary';
          return `/absence/${level}`;
        },

        exportToExcel() {
            this.loading = true;
            const table = document.getElementById("reservationTable").cloneNode(true);
            const ws = XLSX.utils.table_to_sheet(table);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, "reservations.xlsx");
        },
    },
    async mounted() {
        if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
        if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
        this.fetchReservation();
    },
}
</script>

<style scoped>
.table-striped-columns>:not(caption)>tr>:nth-child(2n), .table-striped>tbody>tr:nth-of-type(odd)>* {
  --bs-table-bg-type: unset !important;
}

/* ── Mobile: horizontal scroll instead of a desktop-only lockout ──
   Below 991.98px, _tablet.scss's `.absence-page { display: none; }` used
   to hide this whole page (filters + table) behind a "open on desktop"
   message. That rule is shared with payments/index.vue, so it isn't
   edited globally — this scoped override only affects elements rendered
   by THIS component (Vue appends a data-v-* attribute to every scoped
   selector, which out-specifies the plain unscoped class rule). Instead
   of shrinking the table unreadable, the table itself gets a horizontal
   scroll container with a sane minimum width; the filters/pagination
   above and below it stack normally via Bootstrap's existing grid. */
@media only screen and (max-width: 991.98px) {
  .absence-page {
    display: block !important;
  }
}
.table-scroll-x {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
}
.table-scroll-x table {
  min-width: 900px;
}

/* Screen: booking number has its own column (.col-booking); this inline
   copy inside the name cell only exists for print, so keep it out of the
   way here. */
.print-only-inline {
  display: none;
}

@media print {
    /* Root cause of the "N blank pages" bug: the v-print directive
       (vue3-print-nb) builds its print document by cloning EVERY rule out
       of document.styleSheets — not just this component's own CSS — into
       an iframe whose <body> is nothing but the cloned #reservationTable.
       grades/students.vue ships a page-wide, deliberately unscoped rule
       `body * { visibility: hidden !important; }` (revealed only for ITS
       OWN #printReport target) that rides along into that iframe on every
       route, hiding the cloned table while it still reserves its full
       layout height — i.e. "N pages, all blank" (display:none would have
       collapsed to nothing instead). Same root cause already diagnosed and
       fixed the same way for payments/index.vue's #paymentsTable and
       grades/groups/show.vue's #groupStudentsExportTable; mirrored here. */
    #reservationTable,
    #reservationTable * {
        visibility: visible !important;
    }

    /* style.scss's shared `.a4 { width: 196mm; height: 284mm; }` print rule
       is sized for a near-zero print margin this page never declared. With
       Chrome's default margins that's wider than the actual printable
       area, and in this RTL document a block wider than its containing
       block overflows past the LEFT edge while the right border stays
       intact — the reported clipping. The fixed height also cut off any
       rows beyond one page instead of flowing to page 2. Both overridden
       here, scoped to #reservationTable only (style.scss itself is left
       alone so any other page still using the real .a4 cover-page
       behavior is unaffected). */
    #reservationTable {
        height: auto !important;
        min-height: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
        margin: 0 !important;
        direction: rtl;
    }
    #reservationTable table {
        width: 100% !important;
        max-width: 100% !important;
    }
    /* ── Cover page ──
       .first-screen-pdf used to be squashed into a compact inline header
       (page-break-after: avoid) that flowed directly into the table on the
       same page — deliberate at the time, to avoid wasting a whole page on
       three lines of text. Now a real dedicated cover page is wanted, so
       this fills the printable A4 height (min-height, not a fixed height —
       a fixed height taller than the printable area would itself push
       everything onto a spurious extra page) and forces a break to page 2
       right after it. .table-scroll-x carries the matching break-before,
       which is the standard pairing for "next block starts on a new page"
       — Chrome/Blink collapses a break-after on one box and a break-before
       on its very next sibling into a single break, not two, so this does
       not produce a blank page between cover and table. */
    #reservationTable .first-screen-pdf {
        display: flex !important;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100% !important;
        min-height: 250mm;
        height: auto !important;
        border: none !important;
        margin: 0 !important;
        box-sizing: border-box;
        text-align: center;
        page-break-after: always;
        break-after: page;
        page-break-inside: avoid;
        break-inside: avoid;
    }
    #reservationTable .first-screen-pdf .cover-logo {
        max-width: 40mm;
        max-height: 40mm;
        object-fit: contain;
        margin-bottom: 10mm;
    }
    #reservationTable .first-screen-pdf h1 {
        font-size: 2.2rem !important;
        font-weight: 900;
        margin: 0 0 6mm !important;
        color: #000 !important;
    }
    #reservationTable .first-screen-pdf h2 {
        font-size: 1.5rem !important;
        font-weight: 700;
        margin: 0 0 4mm !important;
        color: #111 !important;
    }
    #reservationTable .first-screen-pdf h3 {
        font-size: 1.05rem !important;
        font-weight: 400;
        margin: 0 !important;
        color: #444 !important;
    }
    .table-scroll-x {
        overflow: visible !important;
        max-width: none !important;
        page-break-before: always;
        break-before: page;
    }
    .table-scroll-x table {
        min-width: 0 !important;
    }

    .table>:not(caption)>*>* {
      border-width: 1px !important;
      border-color: #000 !important;
    }
    table * {
        font-size: 0.72rem !important;
        font-weight: 400;
        /* Whatever gray/faded body-text color the cloned app stylesheets
           carry into the print iframe (vue3-print-nb clones every rule —
           see the blank-page note above), this is a professional
           administrative report and needs solid, dark text throughout —
           not washed-out gray. */
        color: #1a1a1a !important;
    }
    #reservationTable table thead th {
        font-weight: 700;
        color: #000 !important;
    }
    button i {
        display: none !important;
    }

    /* style.scss also ships a leftover, unscoped
       `table thead/tbody th/td:nth-child(6),(8) { display:none }` rule
       from an older, narrower table. Its bare `table` selector matches
       this one too — rather than re-deriving nth-child math by hand
       (fragile every time a column is added/removed), force every cell in
       this specific table visible by default, then explicitly hide only
       the booking-number column below (§ A4 column widths). */
    #reservationTable table thead tr th,
    #reservationTable table tbody tr td {
        display: table-cell !important;
    }

    /* ── A4 column widths ──
       table-layout:fixed + explicit widths on the columns that actually
       hold variable-length text (name, phone) lets those breathe, while
       the purely-mark columns (رقم, الشهور) stay compact — they only ever
       hold a short symbol, never a name or number. Neither رقم الحجز nor
       الغياب get their own column any more: booking number is merged into
       the name cell via .print-only-inline (see the name <td> in the
       template), and الغياب was removed from the table entirely (screen
       and print alike) — both together are what free up the width given
       to name/phone below. Priority order per spec: name+booking > phone
       > student number > months. Widths below sum to ~56%; the 11
       unspecified month <th>/<td> columns split the remaining ~44% evenly
       under table-layout:fixed. */
    #reservationTable table {
        table-layout: fixed;
        border-collapse: collapse;
    }
    #reservationTable table th,
    #reservationTable table td {
        padding: 2px 4px !important;
        /* Wrap rather than clip — table-layout:fixed with a narrow column
           would otherwise silently cut off long names/numbers instead of
           just growing the row height (rows are break-inside:avoid, so a
           taller row still can't be split across a page break). */
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;
    }
    #reservationTable table th.col-booking,
    #reservationTable table td.col-booking {
        display: none !important;
    }
    #reservationTable table th.col-index,
    #reservationTable table td.col-index {
        width: 5%;
    }
    #reservationTable table th.col-name,
    #reservationTable table td.col-name {
        width: 32%;
        text-align: right;
        white-space: normal;
    }
    /* Only the student's own name gets the stronger emphasis — the row
       (table * above) stays normal weight, and the booking number right
       next to it stays deliberately smaller so the two don't compete for
       attention. Both are dark text (never faded/gray) — the name is pure
       #000 specifically, per spec; the booking number is a dark gray a
       shade lighter than pure black, enough to read as visually secondary
       without looking washed out. */
    #reservationTable table td.col-name .print-name-text {
        display: inline;
        font-weight: 900;
        font-size: 0.95rem !important;
        color: #000 !important;
    }
    #reservationTable table td.col-name .print-only-inline {
        display: inline;
        font-weight: 400;
        font-size: 0.66rem !important;
        color: #222 !important;
    }
    #reservationTable table th.col-name .print-only-inline {
        display: inline;
        font-size: 0.62rem !important;
        font-weight: 400;
    }
    #reservationTable table th.col-parent,
    #reservationTable table td.col-parent {
        width: 19%;
    }
    #reservationTable table th.month,
    #reservationTable table td.month-cell {
        width: auto;
    }

    /* Repeat the header on every printed page; keep each data row intact
       across a page break instead of splitting it. */
    #reservationTable table thead {
        display: table-header-group;
    }
    #reservationTable table tbody {
        display: table-row-group;
    }
    #reservationTable table tbody tr {
        break-inside: avoid;
        page-break-inside: avoid;
    }
}

.empty-row {
  display: none;
}
@media print {
  .empty-row {
    display: table-row !important;
  }
}
</style>